import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, DatePicker } from 'antd';
import { useUpdateUser } from '../../hooks/useUpdateUser';
interface ProfileData {
  name?: string;
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  gender?: string | null;
  dob?: string | null;
}

export interface EditProfileModalProps {
  open: boolean;
  onClose: () => void;
  userId: string | undefined;
  profile: ProfileData | undefined;
  onSuccess?: () => void;
}

const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
];

export function EditProfileModal({
  open,
  onClose,
  userId,
  profile,
  onSuccess,
}: EditProfileModalProps) {
  const [form] = Form.useForm();
  const updateUser = useUpdateUser(userId, {
    onSuccess: () => {
      onClose();
      onSuccess?.();
    },
  });

  useEffect(() => {
    if (open && profile) {
      form.setFieldsValue({
        name: profile.name ?? '',
        phone: profile.phone ?? '',
        email: profile.email ?? '',
        address: profile.address ?? '',
        gender: profile.gender ?? undefined,
        dob: profile.dob ? profile.dob : undefined,
      });
    }
  }, [open, profile, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const dobVal = values.dob?.format?.('YYYY-MM-DD') ?? values.dob;
      await updateUser.mutateAsync({
        name: values.name?.trim(),
        phone: values.phone?.trim() || undefined,
        email: values.email?.trim() || undefined,
        address: values.address?.trim() || undefined,
        gender: values.gender,
        dob: dobVal,
      });
    } catch {
      // Validation or API errors handled by hook
    }
  };

  return (
    <Modal
      title="Edit Profile"
      open={open}
      onOk={handleSubmit}
      onCancel={onClose}
      confirmLoading={updateUser.isPending}
      okText="Save"
      cancelText="Cancel"
      width={480}
      destroyOnClose
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Name is required' }]}
        >
          <Input placeholder="Full name" />
        </Form.Item>
        <Form.Item
          name="phone"
          label="Phone"
          rules={[{ required: true, message: 'Số điện thoại là bắt buộc' }]}
        >
          <Input placeholder="Số điện thoại" />
        </Form.Item>
        <Form.Item name="email" label="Email (optional)">
          <Input type="email" placeholder="email@example.com" />
        </Form.Item>
        <Form.Item name="address" label="Address">
          <Input placeholder="Address" />
        </Form.Item>
        <Form.Item name="gender" label="Gender">
          <Select
            placeholder="Select gender"
            allowClear
            options={GENDER_OPTIONS}
          />
        </Form.Item>
        <Form.Item name="dob" label="Date of Birth">
          <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
